import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Inject, LOCALE_ID, Pipe } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppSettingsDto } from '../../services/api.services';
import { SettingsDrivenPipeOverride } from './settings-driven-pipe-override';

@Pipe({
  name: 'percent',
  pure: false,
  standalone: false
})
export class SettingsDrivenPercentPipe extends SettingsDrivenPipeOverride<PercentPipe> {
  protected getPipe() {
    return new PercentPipe(this.pipeLocale);
  }

  protected onTransform(pipe: PercentPipe, settings: AppSettingsDto, value: any, digitsInfo?: string, locale?: string) {
    let locale_ = locale ?? settings.locale ?? this.pipeLocale;

    return pipe.transform(value, digitsInfo, locale_);
  }
}
